import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { EBillTbtTocComponent } from '@ruby/modules/ebill/submodules/ebill-tbt-toc/components/ebill-tbt-toc.component';
import { EbillTbtTocContainer } from '@ruby/modules/ebill/submodules/ebill-tbt-toc/containers/ebill-tbt-toc.container';
import { EBillTbtTocRoutingModule } from '@ruby/modules/ebill/submodules/ebill-tbt-toc/ebill-tbt-toc-routing.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [EBillTbtTocComponent, EbillTbtTocContainer],
  imports: [
    CommonModule,
    EBillTbtTocRoutingModule,
    NSGridModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    NSSkeletonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    PipesModule
  ],
  exports: [EbillTbtTocContainer]
})
export class EBillTbtTocModule {}
